import { renderFont } from '@empiriecom/module-components/ThemeProvider';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const HeadlineWrapper = styled.div<{ mobile: boolean }>`
  margin-bottom: 0.25rem;
  font-size: ${({ mobile }) => (mobile ? '0.813rem;' : '0.938rem')};
  ${({ theme }) => renderFont('base', 'bold', theme)}
`;

export const CompactHeadline: FunctionComponent<{ mobile: boolean; name: string }> = ({
  mobile,
  name,
}): JSX.Element => (
  <HeadlineWrapper data-testid="compact-product-headline" mobile={mobile}>
    {name}
  </HeadlineWrapper>
);

export default CompactHeadline;
